var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"to":{ name: 'M_Keypads' },"disabled":_vm.disabled}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-dots-grid")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Keypads")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }